module.exports = __webpack_public_path__ + "img/parkPoint.94129db9.png";